import { BundleResourcesPackage } from "resource-system";
import { Texture } from "@pixi/core";
export class PauseResourcesPackage extends BundleResourcesPackage {
    public constructor() {
        super("PauseResourcesPackage");
    }
    public get assets_popups_pause_frame_png(): Texture {
        return this.resource<Texture>("assets/popups/pause/frame.png");
    }
}

